// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"LoadingSpinner-module_spinnerContainer_b708d","spinner":"LoadingSpinner-module_spinner_9d614","spin":"LoadingSpinner-module_spin_a3116"};